import Component from './Sidebar';

export default Component;
